import React, { useEffect, useState } from 'react'
// Third
import { Col, Row } from 'antd'

// Component
// import ScheduleBox from '../components/ScheduleBox'
import MainHeader from '../components/MainHeader'
import LeagueScoreCard from '../components/cards/leagueScoreCard'
import Pagination from '../components/Pagination'

// Mock Data
// import { leagueScoreData } from './mockData'
import { useNavigate } from 'react-router-dom'
import { getScheduleByWeek, updateDate } from '../redux'
import Loader from '../components/Loader'
import { useSelector, useDispatch } from 'react-redux'

const LeagueScore = () => {
  // const CURRENT_WEEK = useSelector((state) => state?.user.currentWeek)
  const SETTING = useSelector((state) => state?.user?.setting)

  const navigate = useNavigate()
  const isAuthenticated = localStorage.getItem('token')
  !isAuthenticated && navigate('/transactions')

  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  // const [week, setWeek] = useState(CURRENT_WEEK)

  const dispatch = useDispatch()

  useEffect(() => {
    getDataByWeek()
  }, [SETTING?.week])

  const getDataByWeek = async () => {
    setLoading(true)
    const res = await getScheduleByWeek(SETTING?.week)
    setData(res)
    setLoading(false)
  }

  const handlePagination = (page) => {
    // setWeek(page)
    dispatch(updateDate(page))
  }

  return (
    <div className='league_container'>
      <MainHeader headingAndDate={false} />

      <main className='practice_squad_container wrapper'>
        {/* SCHEDULE ONE */}
        {/* <ScheduleBox /> */}

        {/* SCHEDULE TWO */}
        <section className='schedule_box2'>
          <h1>League Scores </h1>
          <Pagination
            title='Go To Week:'
            defaultCurrent={SETTING?.week}
            total={180}
            onChange={handlePagination}
          />
        </section>

        {/* CARDS */}
        <section className='score_card_container'>
          <Row gutter={[30, 20]}>
            {loading ? (
              <Loader />
            ) : data?.length > 0 ? (
              data?.map((value, index) => (
                <Col xs={24} lg={12} xl={12} xxl={8} key={index}>
                  <LeagueScoreCard data={{ ...value, index }} />
                </Col>
              ))
            ) : (
              <p className='no_schedule_text'>No Schedule..</p>
            )}
          </Row>
        </section>
      </main>
    </div>
  )
}

export default LeagueScore
